/**
 * Gestion du dropdown pour la liste des projets en mode mobile
 * Similaire au comportement des dropdowns du thème
 */
document.addEventListener('DOMContentLoaded', function() {
    // Éléments DOM
    const dropdown = document.querySelector('.projets-dropdown');
    const liste = document.querySelector('.projets-list');
    
    // Vérifier si les éléments existent
    if (dropdown && liste) {
        // Événement pour ouvrir/fermer le menu au clic sur le dropdown
        dropdown.addEventListener('click', function(e) {
            e.preventDefault();
            dropdown.classList.toggle('is-expanded');
        });
        
        // Fermer le dropdown au clic en dehors
        document.addEventListener('click', function(e) {
            // Si on clique en dehors du dropdown et de la liste
            if (!liste.contains(e.target) && !dropdown.contains(e.target)) {
                dropdown.classList.remove('is-expanded');
            }
        });
        
        // Fermer le dropdown après avoir cliqué sur un lien de ville
        const cityButtons = liste.querySelectorAll('.city-button a');
        cityButtons.forEach(button => {
            button.addEventListener('click', function() {
                // Ne ferme le dropdown que sur mobile
                if (window.innerWidth <= 781) {
                    dropdown.classList.remove('is-expanded');
                }
            });
        });

        // FIX: Problème de liens non cliquables sur mobile
        // Assurons-nous que les événements tactiles n'interfèrent pas avec les liens
        if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
            // Pour chaque lien dans la liste des projets
            cityButtons.forEach(button => {
                // Ajout d'un gestionnaire d'événements pour s'assurer que les liens sont cliquables
                button.addEventListener('touchstart', function(e) {
                    // Ne pas empêcher le comportement par défaut pour les liens dans projets-map
                    e.stopPropagation(); // Empêche la propagation à d'autres gestionnaires d'événements
                });
            });
            
            // S'assurer que les éléments parents ne bloquent pas les clics
            liste.addEventListener('touchstart', function(e) {
                if (e.target.closest('.city-button a')) {
                    // Laisser l'événement se propager naturellement pour les liens
                    return;
                }
            });
        }
    }
});
